import { Badge as BadgeComponent } from './Badge';
import { BadgeNumber as Number } from './Number';
import { BadgeDot as Dot } from './Dot';
import { BadgeText as Text } from './Text';
export var Badge = Object.assign(BadgeComponent, {
  Number: Number,
  Dot: Dot,
  Text: Text
});